// extracted by mini-css-extract-plugin
module.exports = {"exception":"exception___3dQMI","imgBlock":"imgBlock___VzkS_","imgEle":"imgEle___1zz9C","content":"content___-6DJH","desc":"desc___2ROXV","actions":"actions___1cgdt"};